import { IPhotoSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { IState } from '../../../store';

export const selectOfferPhotos = (state: IState): IPhotoSchema[] | null => {
  return state.offerData.offer.photos;
};
